/**
 * Mega Menu Drag Scroll
 * Permite arrastrar con el mouse para hacer scroll horizontal en los mega menus
 */
document.addEventListener('DOMContentLoaded', function() {
  
  // Debug mode - cambiar a false en producción
  const DEBUG = false;
  
  function log(message, data = null) {
    if (DEBUG) {
      console.log('[MegaMenu Drag]', message, data);
    }
  }
  
  // Solo ejecutar en desktop (1280px+)
  function isDesktop() {
    return window.innerWidth >= 1280;
  }
  
  // Set para evitar inicializar el mismo elemento múltiples veces
  const initializedElements = new WeakSet();
  
  // Función para inicializar el drag scroll en un elemento
  function initDragScroll(element) {
    // Evitar doble inicialización
    if (initializedElements.has(element)) {
      log('Element already initialized, skipping');
      return;
    }
    
    log('Initializing drag scroll for element:', element);
    initializedElements.add(element);
    
    let isDown = false;
    let startX;
    let scrollLeft;
    let hasMoved = false;
    
    // Cambiar cursor cuando está sobre un área scrolleable
    function updateCursor() {
      const isScrollable = element.scrollWidth > element.clientWidth;
      log('Update cursor - Desktop:', isDesktop(), 'Scrollable:', isScrollable, 'ScrollWidth:', element.scrollWidth, 'ClientWidth:', element.clientWidth);
      
      if (isDesktop() && isScrollable) {
        element.style.cursor = 'grab';
        log('Cursor set to grab');
      } else {
        element.style.cursor = 'default';
        log('Cursor set to default');
      }
    }
    
    // Inicializar cursor con delay para asegurar que el contenido esté renderizado
    setTimeout(updateCursor, 100);
    
    // Actualizar cursor cuando cambie el tamaño de ventana
    window.addEventListener('resize', updateCursor);
    
    // Inicio del drag
    element.addEventListener('mousedown', function(e) {
      log('Mouse down event');
      if (!isDesktop()) {
        log('Not desktop, ignoring');
        return;
      }
      
      // Solo drag con botón izquierdo del mouse
      if (e.button !== 0) {
        log('Not left click, ignoring');
        return;
      }
      
      // No hacer drag si se clickea en un link o botón, EXCEPTO si es dentro de mega-menu__item
      const target = e.target.closest('a, button, [role="button"]');
      const isInsideMegaMenuItem = e.target.closest('.mega-menu__item');
      
      if (target && !isInsideMegaMenuItem) {
        log('Clicked on interactive element outside mega-menu__item, ignoring:', target);
        return;
      }
      
      // Si es dentro de mega-menu__item, permitir drag pero marcar que hay un link
      if (target && isInsideMegaMenuItem) {
        log('Clicked on interactive element inside mega-menu__item, allowing drag:', target);
      }
      
      log('Starting drag');
      isDown = true;
      hasMoved = false;
      element.style.cursor = 'grabbing';
      
      startX = e.pageX - element.offsetLeft;
      scrollLeft = element.scrollLeft;
      
      // Prevenir selección de texto durante el drag
      e.preventDefault();
    });
    
    // Final del drag
    element.addEventListener('mouseup', function() {
      if (!isDesktop()) return;
      
      log('Mouse up event');
      isDown = false;
      updateCursor(); // Restaurar cursor apropiado
      
      // Si se movió durante el drag, prevenir clicks en links
      if (hasMoved) {
        log('Had movement, preventing clicks for 100ms');
        setTimeout(() => {
          hasMoved = false;
          log('Movement flag reset, clicks now allowed');
        }, 100);
      }
    });
    
    // Salir del área durante drag
    element.addEventListener('mouseleave', function() {
      if (!isDesktop()) return;
      
      log('Mouse leave event');
      isDown = false;
      updateCursor(); // Restaurar cursor apropiado
    });
    
    // Movimiento del drag
    element.addEventListener('mousemove', function(e) {
      if (!isDesktop()) return;
      if (!isDown) return;
      
      e.preventDefault();
      
      const x = e.pageX - element.offsetLeft;
      const walk = (x - startX) * 2; // Multiplicar por 2 para scroll más rápido
      
      element.scrollLeft = scrollLeft - walk;
      
      // Marcar que se ha movido para prevenir clicks accidentales (threshold más alto para mega-menu items)
      const movementThreshold = 10; // Aumentar threshold para permitir clicks más fáciles
      if (Math.abs(walk) > movementThreshold) {
        hasMoved = true;
        log('Significant movement detected:', walk);
      }
    });
    
    // Prevenir clicks en links cuando se está haciendo drag
    element.addEventListener('click', function(e) {
      if (hasMoved) {
        log('Preventing click due to drag movement on:', e.target);
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
      } else {
        log('Allowing click (no significant movement):', e.target);
      }
    }, true);
    
    // Agregar wheel scroll horizontal como bonus
    element.addEventListener('wheel', function(e) {
      if (!isDesktop()) return;
      
      // Solo si hay overflow horizontal
      if (element.scrollWidth > element.clientWidth) {
        // Si es scroll vertical, convertir a horizontal
        if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
          e.preventDefault();
          element.scrollLeft += e.deltaY;
          log('Wheel scroll applied:', e.deltaY);
        }
      }
    });
    
    log('Drag scroll initialized successfully');
  }
  
  // Inicializar para todos los mega menus
  function initAllMegaMenus() {
    // Buscar mega menus normales (no tabs)
    const megaMenus = document.querySelectorAll('.mega-menu__list:not(.mega-menu__list--tabs)');
    log('Found mega menus:', megaMenus.length);
    
    megaMenus.forEach((menu, index) => {
      log(`Initializing menu ${index + 1}:`, menu);
      initDragScroll(menu);
    });
    
    // Si no encontró ninguno, intentar con un selector más amplio
    if (megaMenus.length === 0) {
      const allMegaMenus = document.querySelectorAll('.mega-menu__list');
      log('No specific mega menus found, trying all:', allMegaMenus.length);
      
      allMegaMenus.forEach((menu, index) => {
        if (!menu.classList.contains('mega-menu__list--tabs')) {
          log(`Initializing fallback menu ${index + 1}:`, menu);
          initDragScroll(menu);
        }
      });
    }
  }
  
  // Inicializar inmediatamente
  log('Starting initialization');
  initAllMegaMenus();
  
  // Reinicializar cuando aparezcan mega menus dinámicamente
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) { // Element node
            // Buscar mega menus en el nodo agregado
            const megaMenus = node.querySelectorAll('.mega-menu__list:not(.mega-menu__list--tabs)');
            if (megaMenus.length > 0) {
              log('New mega menus detected via mutation:', megaMenus.length);
              megaMenus.forEach(menu => {
                initDragScroll(menu);
              });
            }
            
            // También buscar si el nodo mismo es un mega menu
            if (node.classList && node.classList.contains('mega-menu__list') && !node.classList.contains('mega-menu__list--tabs')) {
              log('New mega menu node detected:', node);
              initDragScroll(node);
            }
          }
        });
      }
      
      // También detectar cambios de atributos que puedan hacer visible el mega menu
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        const target = mutation.target;
        if (target.classList.contains('mega-menu__container') && !target.classList.contains('invisible')) {
          log('Mega menu container became visible:', target);
          setTimeout(() => {
            const megaMenus = target.querySelectorAll('.mega-menu__list:not(.mega-menu__list--tabs)');
            megaMenus.forEach(menu => {
              initDragScroll(menu);
            });
          }, 100);
        }
      }
    });
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class']
  });
  
  // También observar cuando los details se abran (mega menus)
  document.addEventListener('toggle', function(e) {
    if (e.target.tagName === 'DETAILS' && e.target.hasAttribute('is') && e.target.getAttribute('is').includes('details-mega')) {
      log('Mega menu details toggled:', e.target);
      setTimeout(() => {
        const megaMenus = e.target.querySelectorAll('.mega-menu__list:not(.mega-menu__list--tabs)');
        megaMenus.forEach(menu => {
          initDragScroll(menu);
        });
      }, 200); // Dar tiempo para que se renderice
    }
  });
  
  // Inicializar de nuevo después de un delay para elementos que se cargan tarde
  setTimeout(() => {
    log('Re-initializing after delay');
    initAllMegaMenus();
  }, 1000);
  
  log('Mega menu drag script loaded');
  
  // Función de prueba global para debugging (ejecutar en consola del navegador)
  window.testMegaMenuDrag = function() {
    console.log('=== Mega Menu Drag Test ===');
    const megaMenus = document.querySelectorAll('.mega-menu__list:not(.mega-menu__list--tabs)');
    console.log('Found mega menus:', megaMenus.length);
    
    megaMenus.forEach((menu, index) => {
      console.log(`Menu ${index + 1}:`, {
        element: menu,
        scrollWidth: menu.scrollWidth,
        clientWidth: menu.clientWidth,
        isScrollable: menu.scrollWidth > menu.clientWidth,
        cursor: menu.style.cursor,
        hasInitialized: initializedElements.has(menu)
      });
    });
    
    console.log('Desktop mode:', isDesktop());
    console.log('=== End Test ===');
  };
}); 